module.exports = __webpack_public_path__ + "media/images/sp/resort_plans/slider_button_next-ce5610b2aba4d6b8bd5dfead0478d04a.svg";